import { buscarConfiguracoesImpressora } from "../../../services/configuracoes-impressora"
import { TextoModel } from "../models/textoModel"
import { ParametrosGeraisInicial, TextoImpressaoInicial } from "./textoImpressaoInicial"

const STORAGE_KEY = "configuracoesDeTexto"

export function getConfiguracoesDeTextoLocal(): TextoModel {
    if (typeof window === "undefined") {
        return TextoImpressaoInicial
    }

    const data = window.localStorage.getItem(STORAGE_KEY)

    if (!data) return TextoImpressaoInicial

    try {
        const parsed = JSON.parse(data)
        return {
            ...TextoImpressaoInicial,
            ...parsed,
            parametrosGerais: {
                ...TextoImpressaoInicial.parametrosGerais,
                ...(parsed.parametrosGerais ?? {}),
            },
        } as TextoModel
    } catch {
        return TextoImpressaoInicial
    }
}

export function setConfiguracoesDeTextoLocal(config: TextoModel) {
    if (typeof window === "undefined") return
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(config))
}

export async function sincronizarConfiguracoesDeTexto(autorizacao: string): Promise<void> {
    try {
        const response = await buscarConfiguracoesImpressora(autorizacao)
        if (response?.retornoErro || !response?.campos) return

        const { parametrosGerais: _pg, id: _id, ...camposIniciais } = TextoImpressaoInicial
        const pg = response.parametrosGerais

        const modelo: TextoModel = {
            id: response.id !== undefined ? String(response.id) : undefined,
            parametrosGerais: {
                ...ParametrosGeraisInicial,
                ...pg,
                exibirLogo: Boolean(pg?.exibirLogo),
            },
            ...camposIniciais,
            ...response.campos,
        }

        setConfiguracoesDeTextoLocal(modelo)
    } catch {}
}
